import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markDeliveryOrderAsCompleted = async ({ deliveryOrderId, notes }: { deliveryOrderId: string; notes: string }) => {
  const response = await mutationExecute({
    variables: {
      deliveryOrderId,
      notes,
    },
    mutation: graphql(`
      mutation MarkDeliveryOrderAsCompleted($deliveryOrderId: String!, $notes: String!) {
        markDeliveryOrderAsCompleted(deliveryOrderId: $deliveryOrderId, notes: $notes) {
          id
          status
        }
      }
    `),
  });

  return response.data?.markDeliveryOrderAsCompleted ?? null;
};
